/**
 * Mobile Menu Toggle
 * Handles burger menu and close button functionality
 */

export function initMenu() {
    const menuBurger = document.querySelector('.menu-burger');
    const menuClose = document.querySelector('.menu-close');
    const menuContent = document.querySelector('.menu-content');
    const navLarge = document.querySelector('[data-nav-large]');
    
    if (!menuBurger || !menuClose || !menuContent) return;
    
    // Open menu
    menuBurger.addEventListener('click', () => {
        menuBurger.classList.add('hidden');
        menuClose.classList.remove('hidden');
        menuContent.classList.remove('hidden');
        menuContent.classList.add('flex');
        if (navLarge) {
            navLarge.classList.add('h-screen');
        }
    });
    
    // Close menu
    menuClose.addEventListener('click', () => {
        menuClose.classList.add('hidden');
        menuBurger.classList.remove('hidden');
        menuContent.classList.add('hidden');
        menuContent.classList.remove('flex');
        // Remove h-screen on mobile when menu is closed
        if (navLarge && window.innerWidth < 1024) {
            navLarge.classList.remove('h-screen');
        }
    });
    
    // Close menu when clicking on a link (optional)
    const menuLinks = menuContent.querySelectorAll('a');
    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            // Only close on mobile
            if (window.innerWidth < 1024) {
                menuClose.classList.add('hidden');
                menuBurger.classList.remove('hidden');
                menuContent.classList.add('hidden');
                menuContent.classList.remove('flex');
                // Remove h-screen when closing menu on mobile
                if (navLarge) {
                    navLarge.classList.remove('h-screen');
                }
            }
        });
    });
}